import React from 'react';
import { useTranslation } from 'react-i18next';
import { IconButton, TextInput } from '@socialchorus/shared-ui-components';

interface ChatInputProps {
  messageInput: string;
  onMessageChange: (value: string) => void;
  onSendMessage: () => void;
  disabled: boolean;
}

const ChatInput: React.FC<ChatInputProps> = ({
  messageInput,
  onMessageChange,
  onSendMessage,
  disabled,
}) => {
  const { t } = useTranslation();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (messageInput.trim() && !disabled) {
      onSendMessage();
    }
  };

  return (
    <div className="chatbot__input">
      <div className="chatbot__input-content">
        <form onSubmit={handleSubmit}>
          <div className="chatbot__input-form">
            <div className="chatbot__input-field">
              <TextInput
                label="Message"
                value={messageInput}
                onChange={onMessageChange}
                placeholder="Type your message..."
                fullWidth
                disabled={disabled}
                rightWidget={
                  <IconButton
                    type="submit"
                    variant="default"
                    size="default"
                    iconName="send"
                    label={t('chatbot.sendMessage')}
                    disabled={!messageInput.trim() || disabled}
                  />
                }
              />
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ChatInput;
